import { useRef, useEffect } from 'react'
import { useFrame, useLoader } from '@react-three/fiber'

import { TextureLoader } from 'three/src/loaders/TextureLoader'
import { Mesh } from 'three'

const Cloud = function (props: any) {
  const cloudRef = useRef<Mesh>(null)

  useEffect(() => {
    // ..
  }, [])

  useFrame((state, delta) => {
    if (cloudRef.current) {
      cloudRef.current.rotation.y += 0.001
    }
  })

  const textureMap = useLoader(
    TextureLoader,
    `${process.env.PUBLIC_URL}/assets/earth_cloud.png`
  )
  return (
    <mesh {...props} ref={cloudRef} castShadow>
      <sphereGeometry args={[3.8, 40, 40]}></sphereGeometry>
      <meshStandardMaterial
        map={textureMap}
        transparent
        opacity={0.9}
        depthWrite={false}
        roughness={0.9}
        metalness={0}
      ></meshStandardMaterial>
    </mesh>
  )
}

export default Cloud
